exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__content___TMfUM{display:flex;z-index:1;width:100%;height:100%;position:absolute;left:0;top:0;flex-direction:column;justify-content:flex-end;padding:2em;pointer-events:none;gap:.8em}@media (max-width:768px){.index-module__content___TMfUM{gap:.4em}}.index-module__content___TMfUM h1{padding-top:1em;max-width:500px;font-weight:900;letter-spacing:1px;line-height:1;font-size:32px;margin-bottom:.25em}@media (min-width:768px){.index-module__content___TMfUM h1{margin-bottom:0;font-size:60px}}.index-module__content___TMfUM p{margin-top:.25em;color:#fff;font-weight:500;font-size:21px}@media (min-width:768px){.index-module__content___TMfUM p{font-size:32px}}", ""]);

// exports
exports.locals = {
	"content": "index-module__content___TMfUM"
};